import {h} from 'ui/Framework';

export default h('svg', {
  width: '13',
  height: '12',
  viewBox: '0 0 14 13',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('path', {
      d: 'M0 0h14v14H0z'
    }),
    h('path', {
      d: 'M.583 12.25h2.334v-7H.583v7zm12.834-6.417a1.17 1.17 0 0 0-1.167-1.166H8.57L9.122 2l.018-.187c0-.239-.1-.46-.257-.618L8.266.583 4.428 4.428a1.14 1.14 0 0 0-.345.822v5.833A1.17 1.17 0 0 0 5.25 12.25h5.25c.484 0 .898-.292 1.073-.712l1.762-4.112c.052-.134.082-.274.082-.426V5.886l-.006-.006.006-.047z',
      fill: '#536171',
      fillRule: 'nonzero'
    })
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/icon-thumbs-up.es6.js